<script>
  import { _ } from "./i18n.js";
  import { Page, BlockTitle, Block } from "framework7-svelte";
  import Toolbar from "./Toolbar.svelte";
  import moment from "moment";
</script>

<style>
  :global(h3) {
    color: rgb(0, 122, 255);
  }
</style>

<Page>
  <div class="page-content">
    <BlockTitle medium>{$_('terms.title')}</BlockTitle>

    <Block>
      {@html $_('terms.description')}

      <div style="color: rgb(0, 122, 255); text-align: center; padding: 20px">
        {$_('terms.copyright', {
          values: { date: moment(new Date()).format('Do MMMM YYYY') }
        })}
      </div>
    </Block>
  </div>
  <Toolbar tabLinkActive={'/About'} />
</Page>
